import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Grid } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';

// Types
interface DispatchProps {
    updateQueryString: Function;
}

interface ConnectedProps {
    open: boolean;
}

type Props = DispatchProps & ConnectedProps;

export class CreateTimesheetModal extends React.PureComponent<Props> {
    handleGroupTimesheetClick = (): void => {
        this.props.updateQueryString({
            groupTimesheetModal: true,
            createTimesheetModal: undefined
        });
    };

    handleIndividualTimesheetClick = (): void => {
        this.props.updateQueryString({
            individualTimesheetModal: true,
            createTimesheetModal: undefined
        });
    };

    handleClose = (): void => {
        this.props.updateQueryString({
            createTimesheetModal: undefined
        });
    };

    render(): React.ReactElement {
        const { open } = this.props;

        return (
            <Modal
                open={open}
                onClose={this.handleClose}
                size="tiny"
                centered={false}
                closeIcon
            >
                <ErrorBoundary
                    namespace="CreateTimesheetModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Create Timesheet</Modal.Header>
                    <Modal.Content>
                        <p>Create a timesheet for:</p>
                        <Grid>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    primary
                                    onClick={this.handleGroupTimesheetClick}
                                    fluid
                                >
                                    A Group
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    primary
                                    onClick={
                                        this.handleIndividualTimesheetClick
                                    }
                                    fluid
                                >
                                    One Person
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    open: makeSelectQueryStringBooleanValue('createTimesheetModal')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(CreateTimesheetModal);
